import LacunaWebPKI from "web-pki";
import { mapState } from "vuex"

let webPkiLicense = 'AiYAaWNjYi5wbGF0YWZvcm1haWR0LmlvLHBsYXRhZm9ybWFpZHQuaW9eAGlwNDoxMC4wLjAuMC84LGlwNDoxMjcuMC4wLjAvOCxpcDQ6MTcyLjE2LjAuMC8xMixpcDQ6MTkyLjE2OC4wLjAvMTYscGxheS1pY2NiLnBsYXRhZm9ybWFpZHQuaW8DAFBybwgAAJiRUtui3ggAAeCZVDzPgc/1uDVQQI2eC5g4F4kB4m8wdv8Xwa5b6/j9wxFaW5/T7gpjiId1fstAu5Y/WLnOqrAEz2S9gT4oUjQUgaC1/2qDwrJGg35lddDezm4gyquG53aP2EXArXVPmF3g2XiIiwnoukq6zPCHVLcZgphHn+u9M/3zKIS839bsR/N+jvZ1zFIINoxWleOAFA7UxND10SAn290NjpMU04peD+5yRV3ARro/O6Jo6rKYPBUbkWCDw2KfFgGdcXl385363c6fCgcFvaxZAPev+bBx4dV6xlH9S6LNZVsar23uXf9IfF8aCR/Sc6T7SOpIVRV6iGDX9iOxSE//NeHFaNY=';

export default {
  data() {
    return {
      pki: {},
      isExtensionInstalled: true,
      certificates: [],
      thumbprint: {}
    }
  },
  created: function () {
    this.pki = new LacunaWebPKI(webPkiLicense)
    if(this.loadWebPKIPlugin){
      this.initWebPKI()
    }
  },
  watch:{
    loadWebPKIPlugin(newVal){
      if(newVal === true){
        this.initWebPKI()
      }
    }
  },
  computed: {
    ...mapState({
      loadWebPKIPlugin: 'loadWebPKIPlugin'
    })
  },
  methods: {
    onWebPkiReady: function () {
      this.isExtensionInstalled = true
      this.loadCertificates()
    },
    initWebPKI(){
      this.pki.init({
        ready: this.onWebPkiReady,
        notInstalled: this.onWebPkiNotInstalled
      })
    },
    loadCertificates() {
      this.pki.listCertificates().success(certs => {
        this.certificates = certs;
      })
    },
    readCertificate(thumbprint) {
      return this.pki.readCertificate(thumbprint)
    },
    onWebPkiNotInstalled: function () {
      this.isExtensionInstalled = false
    },
    redirectToInstallPage() {
      this.pki.redirectToInstallPage()
    }
  }
}
